import {
  IClientAccountForm,
  IClientAccountResponse,
} from 'services/client-account/types';

export const queryToForm = (
  query: IClientAccountResponse
): IClientAccountForm => {
  const { id, ...form } = {
    ...query,
    label: query.label ?? { id: '', name: '' },
  };

  return form;
};
